import { render, staticRenderFns } from "./GenerationHistoryDetailCardNaming.vue?vue&type=template&id=e68401e8"
import script from "./GenerationHistoryDetailCardNaming.vue?vue&type=script&lang=js"
export * from "./GenerationHistoryDetailCardNaming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports